import axios, { resHandle } from "@/plugins/axios";



/**
 * @description 获得项目列表
 * @param vCom Vue组件
 * @param params 参数
 */
const GetProjectList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/list", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 项目详情
 * @param vCom Vue组件
 * @param projectId project_id
 */
const GetProjectDetail = (vCom: any, projectId: string): Promise<any> => {
    const params: any = {
        params: {
            project_id: projectId
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/project", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 项目下所有分组
 * @param vCom Vue组件
 */
const GetGroups = (vCom: any, projectId: string): Promise<any> => {
    const params: any = {
        params: {
            project_id: projectId
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/project/groups", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 研究队列高级筛选：研究指标列表
 * @param vCom Vue组件
 * @param projectId project_id
 * @param groupId group_id
 */
const GetTemplatesOfGroup = (vCom: any, projectId: string, groupId: any): Promise<any> => {
    const params: any = {
        params: {
            project_id: projectId,
            group_id: groupId
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/project/yjdl/search/templates", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 中医影像数据中心获得模板列表
 * @param vCom Vue组件
 */
const GetZyyxTemplates = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/hospital/search/templates").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 研究队列高级筛选：研究指标各个题目信息
 * @param vCom Vue组件
 * @param templateId template_id
 */
const GetTopicsOfTemplate = (vCom: any, templateId: string): Promise<any> => {
    const params: any = {
        params: {
            template_id: templateId,
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/project/yjdl/search/topics", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description [中医影像中心]研究队列高级筛选：研究指标各个题目信息
 * @param vCom Vue组件
 * @param templateId template_id
 */
const GetZyyxTopicsOfTemplate = (vCom: any, templateId: string): Promise<any> => {
    const params: any = {
        params: {
            template_id: templateId,
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/hospital/search/topics", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 术语搜素（西医疾病、中医疾病、治法治则、中医证型、中医症状）
 * @param vCom Vue组件
 */
const GetTerms = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/terms", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 数据采集：编辑、创建数据
 * @param vCom Vue组件
 * @param params 参数
 */
const PostContents = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/content", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch((err: any) => {
            reject(err);
        });
    });
};

/**
 * @description 所有crf量表模板列表页【不分页】【除掉该访视下】
 * @param vCom Vue组件
 */
const GetInterviesExceptCurrentGroup = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/templates/some", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 批量复制crf量表模板
 * @param vCom Vue组件
 * @param params 参数
 */
const PostCreateCrfs = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/templates", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 删除患者
 * @param vCom Vue组件
 */
const DeletePatient = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/project/patient", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 导入数据到科研项目时的数据中心列表
 * @param vCom Vue组件
 */
const GetImportWayCenterList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/import/centers", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 导入治未病数据中心（中医影像数据中心）的患者到科研项目
 * @param vCom Vue组件
 * @param params 参数
 */
const PostImportPatientFromHdr = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/import/hospatients", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 导入临床科研数据中心（名中医传承数据中心）的患者到科研项目
 * @param vCom Vue组件
 * @param params 参数
 */
const PostImportPatientFromCdr = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/import/cenpatients", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};



/**
 * @description 导入治未病数据中心（中医影像数据中心）的患者测评数据
 * @param vCom Vue组件
 * @param params 参数
 */
const PostImportPatientDataFromHdr = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/import/sbdata", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 导入临床科室数据中心（名中医传承数据中心）的患者量表数据
 * @param vCom Vue组件
 * @param params 参数
 */
const PostImportPatientDataFromCdr = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/import/cendata", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 某访视下所有crf量表
 * @param vCom Vue组件
 */
const GetTemplatesOfInterview = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/templates", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 某分组下所有访视
 * @param vCom Vue组件
 */
const GetInterviews = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/interviews", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 在数据中心（临床或名中医）获取当前用户有权限可使用的分中心
 * @param vCom Vue组件
 */
const GetHospitalsOfLcksOrMzy = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/user/hospitals", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 研究队列，临床科室，名中医：患者列表页
 * @param vCom Vue组件
 * @param params 参数
 */
const PostFetchPatients = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/yjdl/patients", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 所有研究项目列表
 * @param vCom Vue组件
 */
const GetAllProject = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/all").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 模板详情页（研究指标）
 * @param vCom Vue组件
 */
const GetCrfsMuban = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/template", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 所有crf量表模板列表（研究指标）[分页]
 * @param vCom Vue组件
 */
const GetCrfs = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/templates/all", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 量表收集数据数
 * @param vCom Vue组件
 */
const GetCount = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/template/content/count", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description CRF量表重命名
 * @param vCom Vue组件
 */
const RenameCRF = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/template/do", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description CRF量表删除
 * @param vCom Vue组件
 */
const DeleteCRF = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/project/template", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 量表发布
 * @param vCom Vue组件
 */
const GoPublish = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/template/publish", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 停止量表发布
 * @param vCom Vue组件
 */
const StopPublish = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/template/unpublish", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 量表统计患者列表
 * @param vCom Vue组件
 */
const GetPatients = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/template/stats/patients", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description crf量表统计
 * @param vCom Vue组件
 */
const GetCrfStatistics = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/template/stats", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 删除内容
 * @param vCom Vue组件
 */
const DeleteContent = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/project/content", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description h5页面患者搜索
 * @param vCom Vue组件
 */
const PatientSearch = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/app/patient/search", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description h5页面添加或者编辑患者
 * @param vCom Vue组件
 */
const EditPatient = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/app/patient", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description h5页面获取量表
 * @param vCom Vue组件
 */
const GetGauge = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/app/patient/template", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description h5页面量表保存
 * @param vCom Vue组件
 */
const SaveGauge = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/app/patient/content", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取量表小程序token
 * @param vCom Vue组件
 */
const GetToken = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/app/access_token").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取量表小程序二维码
 * @param vCom Vue组件
 */
const GetQRcode = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/app/patient/qrcode", params, { responseType: 'arraybuffer' }).then(({ data }) => {
            resolve(data);
            // resHandle(vCom, data).then(() => {
            //     resolve(data.data);
            // });
        }).catch(() => {
            reject();
        });
    });
};

export {
    GetProjectList, GetProjectDetail, GetGroups, GetTemplatesOfGroup, GetTopicsOfTemplate, GetTerms, PostContents,
    GetInterviesExceptCurrentGroup, PostCreateCrfs, DeletePatient, GetImportWayCenterList, PostImportPatientDataFromHdr,
    GetTemplatesOfInterview, GetInterviews, PostImportPatientFromHdr, PostImportPatientDataFromCdr, PostImportPatientFromCdr, GetHospitalsOfLcksOrMzy,
    PostFetchPatients, GetAllProject, GetCrfs, GetZyyxTemplates, GetZyyxTopicsOfTemplate, DeleteContent, GetCrfStatistics, GetPatients, DeleteCRF, RenameCRF,
    GetCrfsMuban, StopPublish, GoPublish, PatientSearch, EditPatient, GetCount, SaveGauge, GetGauge, GetToken, GetQRcode
};

